import Api from './ApiWAService'

export default {
    // Envio via template (janela de 24h fechada — única opção permitida pela Meta)
    create(data) {
        return Api().post(`whatsapp/send-message`,
            {
                "to": data.phone,
                "templateName": data.templateName || "simple",
                "components": [
                    {
                        "type": "body",
                        "parameters": [
                            { "type": "text", "text": data.message }
                        ]
                    },
                ]
            }
        );
    },

    // Envio de forma livre (texto/mídia/reply) — janela de 24h aberta
    sendFreeform({ to, kind = 'text', text = '', media = null, replyToWAId = null }) {
        const formData = new FormData();
        formData.append('to', to);
        formData.append('kind', kind);
        if (text) formData.append('text', text);
        if (replyToWAId) formData.append('replyToWAId', replyToWAId);
        if (media) formData.append('media', media);
        return Api().post(`whatsapp/send-freeform`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    // Estado da janela de 24h da conversa (libera/restringe o input do chat)
    getConversationWindow(phone) {
        return Api().get(`whatsapp/conversation-window/${encodeURIComponent(phone)}`);
    },

    // Marca a conversa como lida (zera não lidas + ✓✓ azuis para o contato via fila)
    markConversationRead(phone) {
        return Api().post(`whatsapp/conversations/read`, { phone });
    },

    // Envia reação (emoji) a uma mensagem; emoji vazio remove
    sendReaction({ to, targetWAId, emoji = '' }) {
        return Api().post(`whatsapp/send-reaction`, { to, targetWAId, emoji });
    },

    // Mensagem interativa (reply buttons / lista / botão CTA) — janela aberta
    sendInteractive({ to, interactive, replyToWAId = null }) {
        return Api().post(`whatsapp/send-interactive`, { to, interactive, replyToWAId });
    },

    // Template aprovado pelo nome (funciona com a janela fechada)
    sendTemplate({ to, templateName, language = null, values = {} }) {
        return Api().post(`whatsapp/send-template`, { to, templateName, language, values });
    },

    // "Digitando..." para o contato (best-effort, some em 25s)
    sendTyping(phone) {
        return Api().post(`whatsapp/typing`, { phone });
    },
}
